<mat-sidenav-container class="sidenav-container">

  <mat-sidenav #drawer class="sidenav pl-2" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">

    <div class="logo-negocio" routerLink="/dashboard/index">
      <!-- <img src="../../../assets/img/LOGO_LM_2.svg" alt=""> -->
    </div>

    <!-- <mat-toolbar></mat-toolbar> -->

    <mat-nav-list>
      <a mat-list-item routerLink="/dashboard/incidencias">
        <mat-icon class="mr-2">trending_up</mat-icon>
        Ventas y egresos
      </a>
      <a mat-list-item routerLink="/dashboard/productos">
        <mat-icon class="mr-2">shopping_bag</mat-icon> Productos
      </a>
      <a mat-list-item routerLink="/dashboard/clientes">
        <mat-icon class="mr-2">group</mat-icon> Clientes
      </a>
      <a mat-list-item routerLink="/dashboard/balance">
        <mat-icon class="mr-2">attach_money</mat-icon> Balances
      </a>
      <mat-divider *ngIf="company == lm"></mat-divider>
      <a mat-list-item *ngIf="company == lm" routerLink="/dashboard/presupuestator" class="">
        <mat-icon class="mr-2">monetization_on</mat-icon>Presupuestator
      </a>
      <mat-divider></mat-divider>
      <a mat-list-item routerLink="/dashboard/index">
        <mat-icon class="mr-2">help_outline</mat-icon> Ayuda
      </a>
      <a mat-list-item routerLink="/dashboard/preferences">
        <mat-icon class="mr-2">settings</mat-icon> Configuración
      </a>
      <mat-divider class="mt-5"></mat-divider>
      <a mat-list-item (click)="logout()">
        <mat-icon class="mr-2">logout</mat-icon> Cerrar Sesión
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <img src="../../../assets/img/LOGO_LEVEL_APP.png" alt="" class="logo-img">
    </mat-toolbar>

    <div class="container-nav">
    <!-- <div class="container-fluid"> -->
      <router-outlet></router-outlet>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>